import React, { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { Link, useNavigate } from 'react-router-dom'

import loading from '@/assets/lotties/loading.json'
import { Feedback } from '@/components/Feedback/Feedback'
import { WeScreen } from '@/components/WeScreen/WeScreen'
import { AppRoutes } from '@/constants/appRoutes'
import { PersonaInquiryStatusEnum } from '@/store/api/Persona/Persona.types'
import { useLazyUserInfoQuery } from '@/store/api/Users/Users.query'

export const KYCVerificationInProgress = () => {
  const { t } = useTranslation()
  const navigate = useNavigate()
  const [triggerGetUserInfo, { isError, data: userData }] =
    useLazyUserInfoQuery({ pollingInterval: 5000 })

  const KYCStatus: PersonaInquiryStatusEnum =
    userData?.account.statusKYC ?? PersonaInquiryStatusEnum.EMPTY

  const KYCFailed: boolean =
    KYCStatus === PersonaInquiryStatusEnum.DECLINED ||
    KYCStatus === PersonaInquiryStatusEnum.FAILED ||
    KYCStatus === PersonaInquiryStatusEnum.EXPIRED

  const redirectByKYCStatus = (KYCStatus: PersonaInquiryStatusEnum) => {
    if (KYCStatus === PersonaInquiryStatusEnum.APPROVED) {
      navigate(AppRoutes.kycVerificationSuccess)
    } else if (KYCFailed) {
      navigate(AppRoutes.kycVerificationFailed)
    }
  }

  useEffect(() => {
    triggerGetUserInfo()
  }, [triggerGetUserInfo])

  useEffect(() => {
    if (userData) {
      redirectByKYCStatus(KYCStatus)
    }
  }, [KYCStatus, userData])

  return (
    <WeScreen
      useHeader={false}
      isError={isError}
      customViewStyles="max-md:p-10"
    >
      <Feedback
        lottie={loading}
        lottieLoop={true}
        title={t('kyc.inProgress.title')}
        message={t('kyc.inProgress.message')}
        customLottieStyles="w-[800px] h-[200px] max-sm:w-[300px] max-sm:h-[150px] max-md:w-[600px] max-md:h-[150px]"
      />
      <div className="flex flex-col absolute bottom-0 left-0 right-0 mb-2 gap-24 max-sm:gap-10 ">
        <p className="text-neutralColor80 text-sm font-normal text-center">
          {t('kyc.inProgress.waitingTooLong')}
          <span
            className="text-dynamicBlue cursor-pointer"
            onClick={() => navigate(AppRoutes.signUpContactUs)}
          >
            {t('kyc.inProgress.contactUs')}
          </span>{' '}
          {t('kyc.inProgress.soWeCanAssist')}
        </p>
        <p className="text-neutralColor80 text-sm font-medium text-center">
          {t('kyc.inProgress.privacyNote')} &nbsp;
          <Link
            className="text-dynamicBlue"
            target="_blank"
            to={
              'https://help.withpersona.com/articles/7fhhIrBgdgKWTPyWPvGfBH/edit-the-list-of-allowed-domains-to-redirect-to'
            }
          >
            {t('kyc.inProgress.learnMore')}
          </Link>
        </p>
      </div>
    </WeScreen>
  )
}
